import { apiRequest } from "../../apiCall";
import { CheckExistEmailByCustomerIdPayload, SetNewPasswordRequestPayload } from "../../types/Auth/authApiRequestType";



export const setNewPasswordRequest = (params: SetNewPasswordRequestPayload) => apiRequest('UserManagement.setNewPassword',
    {}, `?PasswordRecoveryId=${params.passwordRecoveryId}&NewPassword=${params.newPassword}`,)


export const checkExistEmailByCustomerIdRequest = (params: CheckExistEmailByCustomerIdPayload) => apiRequest('Customer.CheckExistsEmailByCustomerId',
    { ...params }, '',)
